import React from 'react';
import Typography from '@material-ui/core/Typography';
import { sanitizeFieldRestProps } from 'react-admin';

const CustomDateTimeField = props => {
    const { record, source, ...rest } = props;
    const dateValue = record[source];
    const dateEnd = dateValue ? new Date(dateValue) : null;
    if (dateValue) {
        dateEnd.setHours(23, 59, 59, 999);
    }

    return (
        <Typography
            component="span"
            variant="body2"
            {...sanitizeFieldRestProps(rest)}
        >
            {dateValue ? dateEnd.toLocaleString() : ''}
        </Typography>
    );
};

export default CustomDateTimeField;
